import { render, staticRenderFns } from "./HelpContact.vue?vue&type=template&id=0e60f1e8&"
import script from "./HelpContact.vue?vue&type=script&lang=js&"
export * from "./HelpContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports